import React from 'react'
import { useTranslation } from 'react-i18next';
import { TimelineRoute } from './TimelineRoute';

export const Timeline = () => {
    const [t] = useTranslation("global");
    const routes = t('routes', { returnObjects: true })
  return (
    <div className="container-timeline" style={{margin:'0 0 0 0 !important',paddingTop:'100px',paddingLeft:'auto',paddingRight:'auto',backgroundColor:'#000',margin:0}}>
    <div className="row  m-auto">
        <div className="col-md-10  m-auto">
            <div className="main-timeline">
                
                {
                    routes.map((route)=><TimelineRoute key={route.id} {...route}/>)
                }
                
            </div>
        </div>
    </div>
</div>
  )
}
